import React, { Component } from 'react';
import { Button, Input } from 'antd';

class EmailSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newEmail: '',
      confirmNewEmail: '',
      verificationCode: '',
    };
  }

  handleEmailChange(event) {
    this.setState({
      newEmail: event.target.value,
    });
  }

  handleConfirmEmailChange(event) {
    this.setState({
      confirmNewEmail: event.target.value,
    });
  }

  submitNewEmail() {
    if (
      this.state.newEmail == '' ||
      this.state.newEmail == this.props.email ||
      !this.validateEmail(this.state.newEmail)
    ) {
      this.setState({
        error: '* Invalid Email',
      });
      return;
    }

    if (this.state.newEmail != this.state.confirmNewEmail) {
      this.setState({
        error: '* Emails do not match',
      });
      return;
    }

    var newEmailAttr = [
      {
        Name: 'email',
        Value: this.state.newEmail,
      },
    ];

    this.props.cognitoUser.updateAttributes(newEmailAttr, (err, result) => {
      if (err) throw err;
      else {
        this.props.logout();
      }
    });
  }

  validateEmail(email) {
    var reg =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(email);
  }

  render() {
    return (
      <div>
        <label>Current Email: {this.props.email}</label>
        <Input
          placeholder='New Email'
          className='newEmail'
          onChange={this.handleEmailChange.bind(this)}
          value={this.state.newEmail}></Input>
        <Input
          placeholder='Confirm Email'
          className='newEmail'
          onChange={this.handleConfirmEmailChange.bind(this)}
          value={this.state.confirmNewEmail}></Input>
        <p className='errorMessage'>{this.state.error}</p>
        <p>
          {' '}
          <b>
            Submitting a new email will log you out and require that you verify your new email{' '}
          </b>{' '}
        </p>
        <Button
          id='emailBtn'
          className='changeSettingsButtons'
          style={{ height: 35 }}
          onClick={this.submitNewEmail.bind(this)}>
          {' '}
          Submit{' '}
        </Button>
      </div>
    );
  }
}

export default EmailSettings;



// WEBPACK FOOTER //
// ./src/components/userSettings/EmailSettings.js